/**
 * Link-in-bio routes shared by the auth proxy, navigation and sign-up links.
 * Browser-safe: no server imports.
 */
export const BIO_WORKSPACE_PATH = '/dashboard/link-in-bio';
export const BIO_PLAN_PATH = `${BIO_WORKSPACE_PATH}/plan`;
export const BIO_ANALYTICS_PATH = `${BIO_WORKSPACE_PATH}?tab=analytics`;
export const MEDIA_KIT_ONBOARDING_PATH = '/onboarding';
export const BIO_LANDING_PATH = '/link-in-bio';

const BIO_BUILDER_ROUTES: ReadonlySet<string> = new Set([BIO_WORKSPACE_PATH, BIO_PLAN_PATH]);
/** Dashboard routes open to accounts that have not finished media-kit onboarding. */
const BIO_ONLY_ROUTES: ReadonlySet<string> = new Set([
  ...BIO_BUILDER_ROUTES,
  '/dashboard/connections',
]);

/** Sign-up that lands in the builder; the proxy resumes this allowlisted `next`. */
export const BIO_SIGNUP_HREF = `/signin?next=${encodeURIComponent(BIO_WORKSPACE_PATH)}`;
/** Sign-in that resumes on the Link in bio Pro plan page. */
export const BIO_PLAN_SIGNIN_HREF = `/signin?next=${encodeURIComponent(BIO_PLAN_PATH)}`;

/**
 * The Made with OwlScran badge on a free public bio. Campaign tags let sign-up
 * attribution (first/last touch) name the badge and the page it was clicked on.
 */
export function bioBadgeHref(slug: string): string {
  const params = new URLSearchParams({
    utm_source: 'bio_badge',
    utm_medium: 'referral',
    utm_content: slug,
  });
  return `${BIO_LANDING_PATH}?${params}`;
}

export function isBioOnlyRoute(pathname: string): boolean {
  return BIO_ONLY_ROUTES.has(pathname);
}

/** Exact builder destinations, matching what the proxy resumes after sign-in. */
export function isBioBuilderRoute(path: string): boolean {
  return BIO_BUILDER_ROUTES.has(path);
}
